import {
	EditCustomerContext,
	IEditCustomerContext,
} from 'modules/CustomersAndRestaurants/Customers/EditCustomer/editCustomerState/editCustomerContext';
import React, { useContext, useEffect, useState } from 'react';
import { switchArrayItems } from 'utils/helpers';
import LanguageBarItem from 'components/LanguageBarItem/LanguageBarItem';
import { TLanguageIDs } from 'types';
import { IStyleContext, StyleContext } from '../../styleState/styleContext';
import style from './LanguageBar.module.scss';

const LanguageBar: React.FC = () => {
	const { setLanguage, mediaSettingsForUpdate, selectedLanguage } = useContext<IStyleContext>(StyleContext);
	const { IDSelectedCustomerDefaultLanguage } = useContext<IEditCustomerContext>(EditCustomerContext);
	const [orderedLanguages, setOrderedLanguages] = useState<TLanguageIDs[]>([]);

	useEffect(() => {
		const availableLanguages = mediaSettingsForUpdate.map((el) => el.languageId);
		const indexOfDefaultLanguage = availableLanguages.findIndex((el) => el === IDSelectedCustomerDefaultLanguage);
		const orderedByDefaultLanguage = switchArrayItems(availableLanguages, indexOfDefaultLanguage, 0);
		setOrderedLanguages(orderedByDefaultLanguage);
	}, [IDSelectedCustomerDefaultLanguage, mediaSettingsForUpdate]);

	useEffect(() => {
		setLanguage(orderedLanguages[0]);
	}, [orderedLanguages.length]);

	return (
		<>
			{orderedLanguages.length ? (
				<div className={style.container} data-test="LanguageBar">
					{orderedLanguages.map((el) => (
						<LanguageBarItem
							key={el}
							languageId={el}
							isActive={selectedLanguage === el}
							onClick={() => setLanguage(el)}
						/>
					))}
				</div>
			) : null}
		</>
	);
};

export default React.memo(LanguageBar);
